import { EntitlementIcon, getRouteUrl, routePaths } from '@css-xp/base';
import React from 'react';
import { Link } from 'react-router-dom';
import {
  EntitlementDetails,
  LinkedEntitlementTypes,
  LinkedProductTypes,
} from '@css-xp/graphtypes/src/generated-types-new';
import { currentEntitlementType } from '@css-xp/base/entitlement-utils';
import { NoData } from '@css-xp/ppc-common';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { useFetchLinkedEntitlementsPPCQuery } from '../../../hooks/use-fetch-linked-entitlements-ppc-query';

interface EntitlementParentProductProps {
  entitlement: EntitlementDetails;
  destinationEntitlementType: Array<LinkedEntitlementTypes>;
  findProducts?: boolean;
  findApps?: boolean;
}

export const EntitlementParentProduct = ({
  entitlement,
  destinationEntitlementType,
  findApps,
  findProducts,
}: EntitlementParentProductProps) => {
  const subscriptionsRoutePPC =
    entitlement?.transactionAccountId &&
    getRouteUrl(routePaths.subscriptions, { txaId: entitlement?.transactionAccountId });

  const { data, loading, error } = useFetchLinkedEntitlementsPPCQuery({
    entitlementId: entitlement.id,
    currentEntitlementType: currentEntitlementType(entitlement),
    destinationEntitlementType,
    productType: entitlement.productType as LinkedProductTypes,
    transactionAccountId: entitlement.transactionAccountId,
    findApps,
    findProducts,
  });

  const entitlementParentData = data?.entitlementDetails?.linkedEntitlements?.find(
    (entitlement) => !entitlement?.relatesFromEntitlements
  );

  if (error || (!entitlementParentData && !loading)) {
    return <NoData />;
  }

  if (loading) {
    return (
      <SkeletonLoaderWrapper>
        <SkeletonLoader width="60%" marginBottom="0" />
      </SkeletonLoaderWrapper>
    );
  }
  return (
    <div className="entitlment-parent-product-info">
      <span className="avatar-container" data-testid="parent-product-name">
        <EntitlementIcon productId={entitlementParentData?.productId as string} className="avatar medium" isCloud />
        {entitlementParentData?.productName}
      </span>
      <Link
        className="parent-product-link"
        to={`${subscriptionsRoutePPC}${entitlementParentData?.entitlementId}`}
        data-testid="parent-product-link"
      >
        {entitlementParentData?.entitlementNumber}
      </Link>
    </div>
  );
};
